<template>
  <ModalBase
    @close-modal="
      $emit('update:modelValue', false), (selectedMovie = undefined)
    "
    v-if="modelValue"
  >
    <section class="modalLayout">
      <h3 class="title">{{ title }}</h3>
      <div class="movieContainer">
        <div class="moviePlayer" v-if="selectedMovie">
          <div class="iframeWrapper" ref="player">
            <iframe
              :src="
                `https://www.youtube.com/embed/${selectedMovie.id}?rel=0&autoplay=1&playsinline=1`
              "
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              v-if="selectedMovie.id"
            />
            <iframe
              :src="`${selectedMovie.vimeo}&autoplay=1&loop=1&autopause=0`"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowfullscreen
              v-else
            />
          </div>
          <div class="tags">
            <span>録画配信</span>
          </div>
          <h4>{{ selectedMovie.title }}</h4>
          <div class="desc">
            {{ selectedMovie.description }}
          </div>
        </div>

        <div class="movieList">
          <div
            v-for="movie in movies.filter((movie) =>
              movie.label.includes('video')
            )"
            :key="movie.id"
            class="movie clickable"
            @click="selectMovie(movie)"
          >
            <img v-if="movie.thumb" :src="movie.thumb" alt="" />
            <img v-else src="@/assets/images/common/noimg.jpg" alt="" />
            <div class="tags">
              <span>録画配信</span>
            </div>
            <h4>{{ movie.title }}</h4>
            <div class="desc">
              {{ movie.description }}
            </div>
          </div>
        </div>
      </div>
    </section>
  </ModalBase>
</template>

<script lang="ts">
import { ref, defineComponent } from 'vue'
import ModalBase from '../genenral/ModalBase.vue'
import smoothscroll from 'smoothscroll-polyfill'
export default defineComponent({
  name: 'MovieModal',
  components: {
    ModalBase
  },
  props: {
    modelValue: Boolean,
    movies: Array,
    title: String
  },
  setup() {
    smoothscroll.polyfill()
    const player = ref<any>(undefined)
    const selectedMovie = ref<any>(undefined)
    const selectMovie = (movie: any) => {
      selectedMovie.value = movie
      player.value.scrollIntoView({ behavior: 'smooth' })
    }
    return {
      player,
      selectedMovie,
      selectMovie
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

::v-deep(.modal) {
  height: 100%;
  @include mixins.mediaMax() {
    width: 100%;
  }
}
.modalLayout {
  display: grid;
  grid-template:
    'title' 24px
    'movie' 1fr;
  gap: 28px;
  height: 100%;
}
.title {
  text-align: center;
  font-size: 18px;
  line-height: 18px;
  font-weight: 500;
}
.movieContainer {
  overflow-y: scroll;
  letter-spacing: 0;
}
.moviePlayer {
  margin-bottom: 32px;
  .iframeWrapper {
    position: relative;
    padding-bottom: 56.25%;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
.movieList {
  display: grid;
  @include mixins.media() {
    grid-template-columns: repeat(2, 1fr);
  }
  gap: 32px 40px;
}

.tags {
  font-size: 10px;
  margin-top: 16px;
  span {
    background-color: var.$color-sub-bg-g;
    padding: 2px 4px;
    + span {
      margin-left: 4px;
    }
  }
}
h4 {
  font-weight: 500;
  margin: 8px 0;
  line-height: 14px;
}
.desc {
  font-size: 13px;
  line-height: 1.8em;
}
</style>
